<app-block-wrapper
  [_editable]="_editable"
  [style]="style"
  [class.dark]="style[0]?.background === 'dark' || style[0]?.background === 'black'"
  [class.black]="style[0]?.background === 'black'"
>
  <div class="company-logo-list">
    @if (contentAboveHtml) {
      <div [innerHTML]="contentAboveHtml" class="above-logos-content standard-dark-text"></div>
    }
    @if (companies && !companies.length) {
      <div class="empty">EMPTY COMPANY LOGO LIST</div>
    }
    <div
      class="company-list"
      [class.with-ratings]="showRating"
      [style.--item-count]="companies.length"
      [class.animated]="companies.length > 6"
    >
      <div class="company-list-inner" [style.animation-duration]="companies.length * 5 + 's'">
        @for (company of companies; track company) {
          @if (!showRating) {
            <img
              [src]="company.logo.filename | storyblokCdn"
              [alt]="company.logo.alt"
              [attr.width]="company.dimensions.width"
              [attr.height]="company.dimensions.height"
              class="company-list-item"
            />
          } @else {
            <div class="company-list-item">
              <img
                [src]="company.logo.filename | storyblokCdn"
                [alt]="company.logo.alt"
                loading="lazy"
                [attr.width]="company.dimensions.width"
                [attr.height]="company.dimensions.height"
              />
              <div class="stars">
                @for (star of getStars(company.rating); track star) {
                  <div [class]="star"></div>
                }
              </div>
            </div>
          }
        }
        @if (companies.length > 6) {
          @for (company of companies; track company) {
            @if (!showRating) {
              <img
                [src]="company.logo.filename | storyblokCdn"
                [alt]="company.logo.alt"
                [attr.width]="company.dimensions.width"
                [attr.height]="company.dimensions.height"
                class="company-list-item extra"
              />
            } @else {
              <div class="company-list-item extra">
                <img
                  [src]="company.logo.filename | storyblokCdn"
                  [alt]="company.logo.alt"
                  [attr.width]="company.dimensions.width"
                  [attr.height]="company.dimensions.height"
                />

                <div class="stars">
                  @for (star of getStars(company.rating); track star) {
                    <div [class]="star"></div>
                  }
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</app-block-wrapper>
